import { lazy, type ComponentType } from 'react'

const RELOAD_KEY = 'chunkReloadAt'
// Don't reload more than once per window — guards against an infinite reload loop
// if the chunk genuinely can't load (e.g. it 404s for a real reason, not a stale deploy).
const RELOAD_COOLDOWN_MS = 10_000

// React.lazy that recovers from a failed dynamic import. The common cause is a deploy
// rotating hashed chunk filenames while a tab is still open: the old index references a
// chunk URL that no longer exists, so the import 404s and (with Suspense fallback={null})
// the route would render blank forever. Here we reload once to fetch the fresh manifest,
// then fall through to the real error on a repeat failure.
export function lazyWithReload<T extends ComponentType<any>>(factory: () => Promise<{ default: T }>) {
    return lazy(() =>
        factory().catch((err) => {
            const last = Number(sessionStorage.getItem(RELOAD_KEY) || 0)
            if (Date.now() - last > RELOAD_COOLDOWN_MS) {
                sessionStorage.setItem(RELOAD_KEY, String(Date.now()))
                window.location.reload()
                // Hold the promise so nothing renders while the reload takes over.
                return new Promise<{ default: T }>(() => {})
            }
            throw err
        })
    )
}
